import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Box,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import Form1 from "./Form1";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { editTournament } from "../../../api/editTournament";
import { editClub } from "../../../api/editClub";
import TournamentModal from "./TournamentModal";
import { generateRandomNumber } from "../../../helper/generateRandom";
import { fetchTounamentData } from "../../../action/userOwnTournament";
import AgeConsentModal from "../../Modals/user/ageConsentModal/Modal";
import { useSkipFirstRender } from "../../../hooks/useSkipFirstRender";

const AddGoalForm = ({ editTournamentDetails }) => {
  const [next, setNext] = useState(false);
  const userData = useSelector((state) => state.user);
  const token = useSelector((state) => state.auth.token);

  const [ageConsent, setAgeConsent] = useState(false);
  const [confirmAgeConsent, setConfirmAgeConsent] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [newClub, setNewClub] = useState(false);
  const formRef = useRef(null);
  const [finalInvitedUsers, setFinalInvitedUsers] = useState(
    editTournamentDetails?.clubMembers?.map((data) => data.clubMemberDetail) ||
      null,
  );
  const [editTableVideo, setEditTableVideos] = useState(
    editTournamentDetails?.clubMembers?.map((data) => ({
      id: data.id,
      link: data.video_link,
    })) || [],
  );
  const removedUsersRef = useRef(
    editTournamentDetails?.clubMembers?.map((data) => data.clubMemberDetail) ||
      [],
  );
  const [addTournamentFormSubmited, setAddTournamentFormSubmited] =
    useState(false);

  const [errorState, setErrorState] = useState("");
  const [formErrors, setFormErrors] = useState(false);
  const [goalVideos, setGoalVideos] = useState([
    {
      goal: "",
      // club_name: "",
      goal_scorer: "",
      checked: false,
      edited: true,
      error: "",
      visibility: 1,
      key_Id: generateRandomNumber(5),
    },
  ]);

  // "";

  useEffect(() => {
    if (editTournamentDetails?.ClubGoals) {
      setGoalVideos(() => {
        return editTournamentDetails.ClubGoals.map((data) => ({
          goal: data.video_link,
          id: data.id,
          // club_name: data.club,
          goal_scorer: data.goal_scorer,
          visibility: data.visibility,
          edited: false,
          checked: true,
          validated: true,
          key_Id: generateRandomNumber(5),
          user_id: data.user_id,
        }));
      });
    }
  }, [editTournamentDetails]);


  const [deletedVideos, setDeletedVideos] = useState([]);

  let initialValues;
  if (editTournamentDetails) {
    initialValues = {
      title: editTournamentDetails?.title || "",
      image: editTournamentDetails?.club_logo || "",
      description: editTournamentDetails?.description || "",
      category: Number(editTournamentDetails?.category) || 1,
      from_uk: editTournamentDetails?.from_uk ? 1 : 0 || 0,
      region: editTournamentDetails?.region || "",
      // club: editTournamentDetails?.club || "",
      video: editTournamentDetails?.ClubGoals.map(
        (videoData) => videoData.video_link,
      ),
      visibility: editTournamentDetails?.visibility ? 1 : 0,
      subCategory: editTournamentDetails?.clubSubCat?.sub_category || null,
      childCategory: editTournamentDetails?.clubSubCat?.id || null,
    };
  } else {
    initialValues = {
      image: "",
      title: "",
      description: "",
      category: null,
      from_uk: null,
      region: "",
      // club: "",
      video: [],
      visibility: 1,
      subCategory: null,
      childCategory: null,
    };
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      description: Yup.string().required("Description is required"),
      category: Yup.number().required("Category is required"),
      from_uk: Yup.number().required("Video From is required"),
      region: Yup.string().required("Region is required"),
      // club: Yup.string().required("Club Name is required"),
      image: Yup.mixed().required("The club image is required"),
      video: Yup.mixed().required("Video is required"),
      visibility: Yup.string().required("Visibility is required"),
      subCategory: Yup.string()
        .nullable()
        .when("category", {
          is: 6,
          then: (schema) => schema.required("Please select boys or girls"),

          otherwise: (schema) => {},
        }),
      childCategory: Yup.string()
        .nullable()
        .when("subCategory", {
          is: (value) => value,
          then: (schema) =>
            schema.required("Please select age category for boys or girls"),

          otherwise: (schema) => {},
        }),
    }),
    validateOnChange: true,
    onSubmit: async (values) => {
      const video_meta = [];
      const videos = [];
      const editedVideoMeta = [];

      if (!finalInvitedUsers || finalInvitedUsers?.length == 0) {
        toast.error("Please invite atleast one user.");
        return;
      }

      let error = false;

      if (formErrors) {
        setErrorState("Please add the goal videos");
        return;
      } else {
        setErrorState("");
      }

      goalVideos.map((prev, index) => {
        if (
          prev.checked &&
          prev.goal_scorer.trim() !== ""
          // prev.club_name.trim() !== ""
        ) {
          return prev;
        } else {
          // "";
          error = true;
          // setSumitForms(false);
          return { ...prev, error: "Please add the goal video" };
        }
      });

      if (error) {
        setErrorState("Please add the goal videos");
        // toast.error("Please add the goal videos");
        return;
      } else {
        setErrorState("");
      }

      goalVideos.map((data, index) => {
        videos.push(data.goal);
        if (data?.id) {
          editedVideoMeta.push({
            club_name: data.club_name,
            goal_scorer: data.goal_scorer,
            id: data.id,
            visibility: data.visibility,
          });
        } else {
          video_meta.push({
            club_name: data.club_name,
            goal_scorer: data.goal_scorer,
            fileName: data.goal.name,
            visibility: data.visibility,
          });
        }
      });

      const removedUsers = removedUsersRef.current?.filter(
        (member) => !finalInvitedUsers?.find((fm) => fm.id == member.id),
      );
      console.log(
        removedUsersRef,
        "ldkfadsklfldsk",
        finalInvitedUsers,
        "jldkfjlasdkfjlasfj",
        removedUsers,
      );


      const data = {
        title: values.title,
        category: values.category,
        from_uk: values.from_uk,
        region: values.region,
        // club: values.club,
        video: videos,
        video_meta,
        user_id: userData.data.id,
        invite_users: finalInvitedUsers,
        visibility: values.visibility,
        description: values.description,
        image: values.image,
        delete_videos: deletedVideos,
        subCategory: values.childCategory,
        editedVideoMeta,
        removedUsers,
      };

      try {
        setLoading(true);
        let resdata;
        if (editTournamentDetails) {
          data.club_id = editTournamentDetails.id;
          resdata = await editClub("/clubs/editClub", data, token);
        } else {
          resdata = await editClub("/clubs/createClub", data, token);
        }

        if (resdata?.success) {
          // toast.success(resdata.message);
          setNext(false);
          setOpenModal(true);
          setNewClub(resdata?.data);
          // dispatch(fetchTounamentData(token, "", userData.data.id));
        } else {
          const msg = resdata?.rejectedFiles?.reduce(
            (m, c, _) => (m += `\n${c?.originalname}:${c?.reason}`),
          );
          toast.error(resdata.message + msg);
          // toast.error(resdata.message);
        }
      } catch (error) {
        if (error?.response) {
          const msg = error?.response?.data?.rejectedFiles?.reduce(
            (m, c, _) => (m += `\n${c?.originalname}:${c?.reason}`),
          );
          if (msg) {
            toast.error(error.message + msg);
          } else {
            toast.error(error?.response?.data?.message);
          }
        } else {
          toast.error(error.message);
        }
      } finally {
        setLoading(false);
      }
    },
  });

  useSkipFirstRender(() => {
    if (formik.values.category == 6) {
      setAgeConsent(true);
    } else {
      setConfirmAgeConsent(false);
    }
  }, [formik.values.category]);

  useSkipFirstRender(() => {
    if (!confirmAgeConsent && formik.values.category == 6 && !ageConsent) {
      formik.setFieldValue("category", null);
    }
  }, [ageConsent]);

  

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box className="addGoal-inner">
        <Box className="addGoal-header">
          <Button
            sx={{ alignItems: "center", gap: "5px" }}
            onClick={() => {
              if (editTournamentDetails) {
                navigate("/myaccount/3");
              } else {
                navigate("/");
              }
            }}
          >
            {" "}
            <KeyboardBackspaceIcon
              sx={{ color: "white", fontSize: { xs: "20px", md: "30px" } }}
            />{" "}
            <Typography component="h3">Back</Typography>{" "}
          </Button>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {editTournamentDetails ? (
              <Typography component="h1">EDIT CLUB</Typography>
            ) : (
              <Typography component="h1">CREATE CLUB</Typography>
            )}
            {/* <Typography component="h1">
              CREATE TOURNAMENT / CLUB TEAM
            </Typography> */}
          </Box>
        </Box>
        <form
          className="addGoal-form"
          onSubmit={formik.handleSubmit}
          ref={formRef}
          style={{ width: "100%" }}
        >
          <Form1
            formik={formik}
            setFinalInvitedUsers={setFinalInvitedUsers}
            finalInvitedUsers={finalInvitedUsers}
            edited={editTournamentDetails ? true : false}
            editTableVideo={editTableVideo}
            deletedVideos={deletedVideos}
            setDeletedVideos={setDeletedVideos}
            goalVideos={goalVideos}
            setGoalVideos={setGoalVideos}
            setErrorState={setErrorState}
            setFormErrors={setFormErrors}
            addTournamentFormSubmited={addTournamentFormSubmited}
            isAdmin={
              editTournamentDetails
                ? editTournamentDetails?.user_id == userData.data.id
                : true
            }
          />

          <Box className="btn-group" sx={{ width: "100%" }}>
            <Button
              variant="contained"
              className="btn"
              onClick={() => {
                if (formRef.current) {
                  setAddTournamentFormSubmited(true);
                  formik.handleSubmit();
                }
              }}
            >
              {editTournamentDetails ? "Update" : "Publish"}
            </Button>
          </Box>
        </form>
      </Box>
      <TournamentModal
        open={openModal}
        setOpen={setOpenModal}
        edit={editTournamentDetails}
        data={newClub}
      />

      <AgeConsentModal
        open={ageConsent}
        setOpen={setAgeConsent}
        confirm={confirmAgeConsent}
        setConfirm={setConfirmAgeConsent}
      />
    </>
  );
};

export default AddGoalForm;
